import React from "react";
import { Handle, Position } from "reactflow";

import ExtensionHeader from "./ExtensionHeader";

import "./ExtensionIntentNode.scss";

const ExtensionIntentNode = ({ id }) => {

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="entry-node-container">
        <ExtensionHeader
          id={id}
        />
      </div>
    </>
  );
};

export default ExtensionIntentNode;
